const shortLang = {
    en: "En",
    hi: "Hi",
    gj: "Gj",
}

const longLang = {
    en: "English",
    hi: "Hindi",
    gj: "Gujrati",
}

const languages = [
    { short: 'en', long: 'English' },
    { short: 'hi', long: 'Hindi' },
    { short: 'gj', long: 'Gujrati' },
];

export default languages;